export const selectCameraScanResults = state => state.cameraScanResultsState;
